import { render, staticRenderFns } from "./AddAgency.vue?vue&type=template&id=744d5406"
import script from "./AddAgency.vue?vue&type=script&lang=js"
export * from "./AddAgency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports